import { api, ApiRequestConfig } from 'api';
import { UploadReviewPhotoResponse } from './upload-photo-types';

/**
 * Запрос загрузки фото к новому отзыву
 * @param {string} regionCode
 * @param {File} file
 * @returns {Promise<UploadReviewPhotoResponse>}
 */
export const uploadReviewPhoto = (
  regionCode: string,
  file: File,
  config: ApiRequestConfig,
): Promise<UploadReviewPhotoResponse> => {
  const requestPayload = new FormData();
  requestPayload.append('photo', file);

  return api.post<UploadReviewPhotoResponse>(
    'send-review-photos',
    requestPayload,
    { ...config, formData: true },
    { regionCode }
  );
};
